export default "__VITE_PUBLIC_ASSET__e3abdc8b__"